import { Link } from "react-router-dom";
import "../styles/header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe, faHouse} from "@fortawesome/free-solid-svg-icons";
import { useLang } from "../context/LangContext";
import { useEffect, useState } from "react";
import { fetchPageContent } from "../api/contentApi";


export default function Header() {
  const { lang, setLang} = useLang();
  const [content, setContent] = useState ({
    finance_title: "",
    translation_title: "",
    gdpr_title: "",
  });

    useEffect(() => {
    async function loadTitles() {
      try {
        // Fetch each tab separately
        const financeData = await fetchPageContent("finance", lang);
        const translationData = await fetchPageContent("translation", lang);
        const gdprData = await fetchPageContent("gdpr", lang);
        const mainData = await fetchPageContent("main", lang);

        setContent({
          finance_title: financeData.finance_title || "",
          translation_title: translationData.translation_title || "",
          gdpr_title: gdprData.gdpr_title || "GDPR",
          company_name: mainData.company_name || "",
        });
      } catch (err) {
        console.error("Error fetching header titles:", err);
      }
    }

    loadTitles();
  }, [lang]);

    const scrollToFooter = () => {
    const footer = document.getElementById("footer");
    if (footer) {
      footer.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <header className="header">
      <div className="header-left">
        <a href="/" className="logo-link">
          <img src="/logo.png" alt="Logo" className="logo" />
        </a>
        {content.company_name && (
        <Link to="/" className="company-name">
        <span >{content.company_name}</span>
        </Link>
        )}
      </div>
      
      <div className="header-center">
          <nav className="header-services">
        <Link to="/"><FontAwesomeIcon icon={faHouse} className="header-icon"/></Link>
        <Link to="/finance">{content.finance_title}</Link>
        <Link to="/translation">{content.translation_title}</Link>
        <Link to="/gdpr">{content.gdpr_title}</Link>
      </nav>
      </div>

      <div className="header-right">
        <div className="language-switcher">
           <FontAwesomeIcon icon={faGlobe} className="header-icon"/>
           <button
            className={lang === "fi" ? "active" : ""}
            onClick={() => setLang("fi")}
          >
          FI
          </button>
          /
          <button
            className={lang === "ua" ? "active" : ""}
            onClick={() => setLang("ua")}
          >
        UA
          </button>
          /
          <button
            className={lang === "ru" ? "active" : ""}
            onClick={() => setLang("ru")}
          >
          RU
          </button>
        </div>
        <button className="contact-btn" onClick={scrollToFooter}>Contact Us</button>
      </div>
    </header>
  );
}